import React from 'react';

const PartnerWithUs = () => {
  return (
    <section id="contact" className="py-24 bg-gradient-to-br from-gray-900 via-onyx-900 to-gray-900">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6">
          Partner With Us
        </h2>
        <p className="text-lg sm:text-xl text-gray-300 mb-10 leading-relaxed max-w-3xl mx-auto">
          Let’s create solutions that move health and technology forward—together.
        </p>
        <a
          href="https://calendly.com/ashley-onyxroseadvisors/onyx-health-advisory-30-minute-introductory-session"
          className="inline-block bg-accent text-white font-semibold px-10 py-4 rounded-md hover:bg-accent-900 transition-all duration-200 shadow-lg hover:shadow-xl text-lg"
        >
          Schedule a Consultation
        </a>
      </div>
    </section>
  );
};

export default PartnerWithUs;
